export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const USER_UUID = "user_uuid";
export const CLIENT_UUID = "client_uuid";
